export enum FactorisationModeEnum {
    USAGE,
    DEPENDENCIES
}
